import * as types from '../../actions/actionTypes';
import { axios } from '../api/axiosConfig';
import { getTransactionResult } from '../../actions/quickQuotesActions';
import { doMedicalRateCall } from '../../actions/renewalRateActions';
import { checkIsInternalUser } from '../../actions/fullQuotesActions';
import { logError } from '../errorLogging/logError';
import { KEY_NAME, UHC_REN_APIS } from '../errorLogging/logKeys';
import { isUhcRenewals, getMarketType, isMigratedGroup } from '../businessLogic/platformUtils';
import { formatPlanOrRateCallError } from '../formatters/errorFormat';
import { setFetchingAlternateRatingMethod, getCensusRates } from '../../actions/renewalShoppingActions';
import { groupPlansByRiders } from './migratedRiderUtils';
// import { HARDCODED_MED_PLAN_RESPONSE } from './hardcodedMedPlanData';
const apiRoutes = require('../api/apiRouteConfig');

export const callValidateQuoteUhc = (zipCode, stateCode, groupSize, effectiveDate, franchiseCode, ratingCount, arqRequestInd, arqOi, arqSa, arqBit) => {
    return new Promise((resolve, reject) => {
        axios.get(`${apiRoutes.quickQuotes}/validate-quote?zipCode=${zipCode}&stateCode=${stateCode}&groupSize=${groupSize}&effectiveDate=${effectiveDate}${franchiseCode ? `&franchiseCode=${franchiseCode}` : ''}${ratingCount ? `&ratingCount=${ratingCount}` : ''}&arqRequestInd=${arqRequestInd}&arqOi=${arqOi}&arqSa=${arqSa}&arqBit=${arqBit}&busType=RL`)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getGroupChoiceIndicator = (ibrQuote) => {
    const quoteCDD = ibrQuote && ibrQuote.clientDefinedData ? ibrQuote.clientDefinedData.data : [];

    let groupChoiceIndicator = '';
    if(quoteCDD.length > 0) {
        for(let item of quoteCDD) {
            if(item.key === 'EEChoiceIndicator') {
                groupChoiceIndicator = item.value;
                break;
            }
        }
    }
    return groupChoiceIndicator;
}

export const checkAlternateRatingMethodUsed = (selectedPlans) => {
    if (selectedPlans && selectedPlans.length > 0) {
        for (let i = 0; i < selectedPlans.length; i++) {
            if (selectedPlans[i].ibrRatingType) {
                return (
                    selectedPlans[i].ibrRatingType !==
                    selectedPlans[i].defaultRatingType
                );
            }
        }
    }
    return false;
};

export const callGetPlansUhc = (plansRequestBody) => { 
    return (dispatch, getState) => {
        dispatch({
            type: types.SET_IS_FETCHING_MEDICAL_PLANS,
            payload: true
        })
        const { totalEmployed, industryCode }  = getState().renewalShoppingHelper.renewalData ? getState().renewalShoppingHelper.renewalData.Ibr.group.primaryLocation : getState().review.renewalData.Ibr.group.primaryLocation;
        const { zipCode, effectiveDate, situsState } = getState().renewalShoppingHelper.renewalCaseData ? getState().renewalShoppingHelper.renewalCaseData : getState().review.renewalCaseData;
        const fullProps = getState();
        const { renewalShopping } = fullProps;
        const includeSpecialty = false;
        const selectedProducts = ["medical"];
        const viewSpecialty = {
            dental: false,
            life: false,
            ltd: false,
            medical: true,
            std: false,
            sul: false,
            vision: false
        }
        const otherDetails = {
            includeSpecialty: includeSpecialty,
            selectedProducts: selectedProducts,
            viewSpecialty: viewSpecialty,
            sicCode: industryCode.sicCode
        };
        const renewalShoppingRequest = {
            groupSize: totalEmployed,
            zipObj: zipCode,
            effectiveDate: effectiveDate,
            otherDetails: otherDetails,
            
        };
        // Add Internal User Indicator
        plansRequestBody.isInternal = checkIsInternalUser(fullProps.renewals.userRolesPermissions);

        if (isUhcRenewals()) {
            plansRequestBody.isUhcRenewals = true
        }
        if(isUhcRenewals() && plansRequestBody.stateCode === 'CO') {
            const CoExcepIndicator = fullProps?.renewals?.renewalData?.Ibr?.group?.clientDefinedData?.data?.find(cdd=> cdd.key === 'CoExcepSgInd')?.value || 'N';
            plansRequestBody.CoExcepSgInd = CoExcepIndicator ? CoExcepIndicator === 'Y' ? true : false : false;
        }
        axios.post(`${apiRoutes.quickQuotes}/primePlans/check`, plansRequestBody)
            .then(async (res) => {
                const planSearch = await getTransactionResult(res.data.transactionId);
                if (planSearch.statusCode === 400) {
                    throw await planSearch;
                }

                if(situsState==="CA" && effectiveDate ){
                    let coverageDate = new Date(effectiveDate).getUTCDate();
                    if(coverageDate === 15){
                        planSearch.medicalPlans = planSearch.medicalPlans.filter(pln => pln.platform !== 'NICE');
                    }
                }

                await dispatch({
                    type: types.SERVICE.RS.RECEIVE_REN_ADDITIONAL_PLANS,
                    payload: planSearch,
                    renewalShoppingRequest,
                    fullProps: fullProps
                });
                
                //when moving from review to shopping or decide to shopping
                if(situsState === "CA")
                {
                    dispatch(doMedicalRateCall({
                        medicalPlans: planSearch.medicalPlans.map((plan) => {
                            return {code: plan.code, packages: plan.packages, platform: plan.platform}
                        }),
                        getAlternateRatingMethod: checkAlternateRatingMethodUsed(renewalShopping.selectedPlans),
                        allMedicalPlans : planSearch.medicalPlans
                    }))
                }
                else{
                    dispatch(doMedicalRateCall({
                        medicalPlans: planSearch.medicalPlans.map((plan) => {
                            return {code: plan.code, packages: plan.packages}
                        }),
                        getAlternateRatingMethod: checkAlternateRatingMethodUsed(renewalShopping.selectedPlans),
                        allMedicalPlans : planSearch.medicalPlans
                    }));
                }               
            })
            .catch((err) => {
                dispatch({
                    type: types.SERVICE.RS.ERR_REN_ADDITIONAL_PLANS,
                    payload: formatPlanOrRateCallError(err, 'plan', false)
                });
                dispatch({
                    type: types.SET_IS_FETCHING_MEDICAL_PLANS,
                    payload: false
                })
                dispatch({
                    type: types.DISPLAY_ERROR_MESSAGE
                });
                logError(KEY_NAME, UHC_REN_APIS.MEDICAL_PLAN_CHECK, 'uhcServiceHelpers.callGetPlansUhc',plansRequestBody, err);
        });
    }
    
}

/** Rate API Call for getting medical rates */
export const callRateApi = async(requestBody,dispatch ) => {
    return new Promise(async(resolve, reject) => {
        try{
            await axios.post(`${apiRoutes.quickQuotes}/rates/startRates`, requestBody)
            .then(async (res) => {
                const results = await getTransactionResult(res.data.transactionId);
                if (results.statusCode === 400) {
                    throw await results;
                }
                resolve(results.medicalRates);
            })
            .catch(err => {
                dispatch({
                    type: types.DISPLAY_ERROR_MESSAGE
                });
                dispatch({
                    type: types.SET_IS_FETCHING_MEDICAL_PLANS,
                    payload: false
                })
                dispatch(setFetchingAlternateRatingMethod(false));
                logError(KEY_NAME, UHC_REN_APIS.START_RATES, 'uhcServiceHelpers.callRateApi',requestBody, err);
                reject(err);
            })
        }
        catch(err)
        {
            console.log("Error in /startRatesApi :",err)
        }
    })
}
 
/** API Call for fetching UHIC/Oxford migrated medical plans */
export const fetchMigratedUhicMedicalPlans = (migratedUhcRequestBody, reqProps) => {
    return (dispatch, getState) => {
        
        dispatch({
            type: types.SET_IS_FETCHING_MEDICAL_PLANS,
            payload: true
        });
 
        // Return the promise so it can be awaited
        return axios.post(`${apiRoutes.quickQuotes}/cirrus/med-plan-availability`, migratedUhcRequestBody, {
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 30000 // 30 second timeout
        })
        .then(async (res) => {
                if (res.data && res.data.plans && res.data.plans.length > 0) {
                // Store plan-availability data with limitedPlanDistribution for merging later
                const planAvailabilityData = res.data.plans; // Contains limitedPlanDistribution: boolean

                // Create renewalRank mapping from availability response
                const renewalRankMap = new Map(
                    res.data.plans.map(plan => [plan.planCode, plan.renewalRank])
                );
                
                // Create single request body with ALL plans
                const planDetailsRequestBody = {
                    sourceTransactionID: migratedUhcRequestBody.sourceTransactionID || "",
                    planDetailsRequest: res.data.plans.map(plan => ({
                        hiosPlanID: plan.hiosPlanId,
                        //branding: plan.branding || "",
                        branding: "",
                        planCode: plan.planCode,
                        requestType: migratedUhcRequestBody.requestType
                    }))
                };

                // Pass renewalRank mapping to fetchMedicalPlanDetails
                const enrichedReqProps = {
                    ...reqProps,
                    renewalRankMap
                };
                // Make single API call for all plans and wait for it - pass availability data for merging
                await fetchMedicalPlanDetails(planDetailsRequestBody, dispatch, getState, enrichedReqProps, planAvailabilityData);
                return Promise.resolve();
 
            } else if (res.data && res.data.plans && res.data.plans.length === 0) {
                return Promise.resolve();
            }
            else {
                throw new Error('Invalid response format from UHIC plan availability API');
            }
        })
        .catch((err) => {
            
            dispatch({
                type: types.SERVICE.RS.ERR_REN_ADDITIONAL_PLANS,
                payload: formatPlanOrRateCallError(err, 'uhic-plan', false)
            });
 
            dispatch({
                type: types.SET_IS_FETCHING_MEDICAL_PLANS,
                payload: false
            });
 
            dispatch({
                type: types.DISPLAY_ERROR_MESSAGE
            });
 
            // Log the error with context
            logError(KEY_NAME, UHC_REN_APIS.UHIC_PLAN_AVAILABILITY, 'uhcServiceHelpers.fetchMigratedUhicMedicalPlans', migratedUhcRequestBody, err);
            
            // Re-throw the error so the caller knows it failed
            return Promise.reject(err);
        });
    };
};
 
 
/**
 * Helper function to poll for plan details using transaction ID
 * @param {string} transactionId - Transaction ID from initial POST request
 * @param {number} maxAttempts - Maximum number of polling attempts
 * @param {number} pollingInterval - Time between polling attempts in ms
 * @returns {Promise} Resolves with plan details data or rejects with error
 */
const pollForPlanDetails = async (transactionId, maxAttempts = 30, pollingInterval = 5000) => {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            console.log(`Polling for plan details (attempt ${attempt}/${maxAttempts})...`);
            
            const response = await axios.get(
                `${apiRoutes.quickQuotes}/cirrus/med-plan-details/${transactionId}`,
                { timeout: 10000 }
            );

            const status = response.data?.transactionResult?.searchResult?.statusCode;
            const data = response.data?.transactionResult?.searchResult?.data;

            // Check if processing is complete
            if (status === 200 && data && !data.status) {
                console.log('Plan details fetched successfully');
                return data;
            }

            // Check if still processing
            if (status === 202 || (data && data.status === 'PROCESSING')) {
                console.log('Still processing, waiting before next poll...');
                await new Promise(resolve => setTimeout(resolve, pollingInterval));
                continue;
            }

            // Check if failed
            if (data && data.status === 'FAILED') {
                throw new Error(data.error || 'Plan details processing failed');
            }

            // Unexpected status
            throw new Error(`Unexpected response status: ${status}`);

        } catch (error) {
            if (attempt === maxAttempts) {
                console.error('Max polling attempts reached');
                throw error;
            }
            
            // If it's a network error, wait and retry
            if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                console.log('Request timeout, retrying...');
                await new Promise(resolve => setTimeout(resolve, pollingInterval));
                continue;
            }
            
            throw error;
        }
    }
    
    throw new Error('Polling timeout: Plan details not ready after maximum attempts');
};

/** Function to fetch plan details and handle everything internally with batching support */
export const fetchMedicalPlanDetails = async (planDetailsRequestBody, dispatch, getState, reqProps, planAvailabilityData = null) => {
    const fullProps = getState();
 
    const renewalShoppingRequest = {
        groupSize: reqProps.groupSize,
        zipObj: reqProps.zipObj,
        effectiveDate: reqProps.effectiveDate,
        otherDetails: reqProps.otherDetails,
    };

    // Create mapping of planCode -> limitedPlanDistribution from availability data
    const limitedDistributionMap = {};
    if (planAvailabilityData && Array.isArray(planAvailabilityData)) {
        planAvailabilityData.forEach(plan => {
            if (plan.planCode) {
                limitedDistributionMap[plan.planCode] = plan.limitedPlanDistribution || false;
            }
        });
    } else {
        console.warn('⚠️ No planAvailabilityData provided to fetchMedicalPlanDetails');
    }

    // ⚠️ TESTING FLAG - Set to true to use hardcoded data ⚠️
    const USE_HARDCODED_DATA = false;

    try {
        let planDetailsArray;

        if (USE_HARDCODED_DATA) {
            console.warn('⚠️ USING HARDCODED MED PLAN DETAILS DATA ⚠️');
            planDetailsArray = HARDCODED_MED_PLAN_RESPONSE.transactionResult.searchResult.data;
        } else {
            // Original API flow
            // Step 1: Initiate plan details request (returns transaction ID)
            
            const initiateResponse = await axios.post(
                `${apiRoutes.quickQuotes}/cirrus/med-plan-details`,
                planDetailsRequestBody,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    timeout: 30000 // Shorter timeout since this just returns transaction ID
                }
            );

            const transactionId = initiateResponse.data?.transactionId;
            const status = initiateResponse.data?.status;

            if (!transactionId) {
                throw new Error('No transaction ID received from server');
            }

            // Step 2: Poll for results
            if (status === 'COMPLETED') {
                // For small requests, data might be ready immediately. Fetch it once from cache
                const cacheResponse = await axios.get(
                    `${apiRoutes.quickQuotes}/cirrus/med-plan-details/${transactionId}`,
                    { timeout: 10000 }
                );
                planDetailsArray = cacheResponse.data?.transactionResult?.searchResult?.data;
            } else {
                // For large requests or processing status, poll for results
                planDetailsArray = await pollForPlanDetails(transactionId);
            }

            if (!planDetailsArray || !planDetailsArray.medicalPlans) {
                throw new Error('Invalid plan details data received');
            }

        }        
        // Merge renewalRank into plan details and sort by renewalRank
        if (reqProps.renewalRankMap && planDetailsArray.medicalPlans) {
            const renewalRankMap = reqProps.renewalRankMap;
            
            planDetailsArray.medicalPlans = planDetailsArray.medicalPlans.map(plan => {
                // Match using planCode field
                const planCode = plan.code || plan.planCode;
                const renewalRank = renewalRankMap.get(planCode);
                
                // Log warning if renewalRank not found
                if (renewalRank === undefined || renewalRank === null) {
                    console.warn(`⚠️ renewalRank not found for plan code: ${planCode}`);
                }
                
                return {
                    ...plan,
                    renewalRank: renewalRank !== undefined && renewalRank !== null ? renewalRank : 999
                };
            });
            
            // Sort plans by renewalRank in ascending order
            planDetailsArray.medicalPlans.sort((a, b) => a.renewalRank - b.renewalRank);
            
            console.log('✓ Plans sorted by renewalRank');
        }
        
        let platform;
        const includeSpecialty = (reqProps && reqProps.includeSpecialty) ? reqProps.includeSpecialty : false;
        
        if (planDetailsArray.medicalPlans && planDetailsArray.medicalPlans.length > 0) {
            platform = planDetailsArray.medicalPlans[0].platform;
        }
        
        const groupType = fullProps?.renewals?.renewalCaseData?.groupType;
        const isUhicMigrated = groupType?.toUpperCase() === 'UHC';
        const isOxfordMigrated = groupType?.toUpperCase() === 'OXFORD';
        const isMigratedUhic = isMigratedGroup() && isUhicMigrated;
        const isMigratedOxford = isMigratedGroup() && isOxfordMigrated;
        const renewalData = fullProps?.renewalShoppingHelper?.renewalData || fullProps?.renewalData;
        const hasMedicalProduct = renewalData?.members?.some(member => 
            member.products?.some(product => product.type?.toLowerCase() === 'medical')
        ) || false;        
        const currentRenewalShopping = getState().renewalShopping;
        const isMedAddScenario = (isUhicMigrated || isOxfordMigrated) && !hasMedicalProduct && !currentRenewalShopping?.eligibilityCountsEntered;

        // 🔥 CRITICAL: Merge limitedPlanDistribution BEFORE rider grouping
        // This ensures the field is present when riderGroupingData is created
        if (Object.keys(limitedDistributionMap).length > 0 && planDetailsArray.medicalPlans) {
            
            let matchedCount = 0;
            let unmatchedCount = 0;
            
            planDetailsArray.medicalPlans = planDetailsArray.medicalPlans.map(plan => {
                const planCode = plan.code || plan.planCode;
                
                if (planCode && limitedDistributionMap.hasOwnProperty(planCode)) {
                    matchedCount++;
                    console.log(`  ✅ Matched: ${planCode} → LD=${limitedDistributionMap[planCode]}`);
                    return {
                        ...plan,
                        limitedPlanDistribution: limitedDistributionMap[planCode]
                    };
                } else {
                    unmatchedCount++;
                    if (unmatchedCount <= 3) {
                        console.log(`  ❌ No match for plan code: "${planCode}"`);
                    }
                    return {
                        ...plan,
                        limitedPlanDistribution: false // Default to false if not found
                    };
                }
            });
            console.log(`🟢 Merging complete: ${matchedCount} matched, ${unmatchedCount} unmatched out of ${planDetailsArray.medicalPlans.length} plans`);
        } else {
            console.warn('⚠️ Skipping merge: limitedDistributionMap has', Object.keys(limitedDistributionMap).length, 'entries');
            // Ensure all plans have the field even if merge is skipped
            if (planDetailsArray.medicalPlans) {
                planDetailsArray.medicalPlans = planDetailsArray.medicalPlans.map(plan => ({
                    ...plan,
                    limitedPlanDistribution: plan.limitedPlanDistribution || false
                }));
            }
        }

        // Now do rider grouping AFTER merge (so limitedPlanDistribution is included)
        let riderGroupingData = null;
        if (isMigratedUhic || isMigratedOxford) {
            riderGroupingData = groupPlansByRiders(planDetailsArray.medicalPlans);
            console.log('🎯 Rider grouping complete. Non-rider plans:', riderGroupingData.nonRiderPlans.length);
            if (riderGroupingData.nonRiderPlans.length > 0) {
                console.log('🎯 Sample non-rider plan has limitedPlanDistribution:', 
                    riderGroupingData.nonRiderPlans[0]?.limitedPlanDistribution);
            }
        }

        // For migrated UHIC and Oxford groups with riders, only call rates for non-rider plans initially
        let plansForRateCall = (isMigratedUhic || isMigratedOxford) && riderGroupingData
            ? riderGroupingData.nonRiderPlans.filter(plan => plan.code && plan.code.trim() !== '').map((plan) => plan.code)
            : planDetailsArray.medicalPlans.filter(plan => plan.code && plan.code.trim() !== '').map((plan) => plan.code);

        // Safety check: if plansForRateCall is empty but plans exist, fall back to all plans
        if (plansForRateCall.length === 0 && planDetailsArray.medicalPlans.length > 0) {
            console.warn('⚠️ plansForRateCall is empty but medicalPlans exist. Using all plans as fallback.');
            plansForRateCall = planDetailsArray.medicalPlans.filter(plan => plan.code && plan.code.trim() !== '').map((plan) => plan.code);
        }

        if (!isMedAddScenario || currentRenewalShopping?.eligibilityCountsEntered) {
            let employeeCounts = reqProps.employeeCounts;
            if ((isUhicMigrated || isOxfordMigrated) && currentRenewalShopping?.eligibilityCountsEntered && currentRenewalShopping?.eligibilityCounts) {
                employeeCounts = {
                    rftCount: parseInt(currentRenewalShopping.eligibilityCounts.rft) || 0,
                    atneCount: parseInt(currentRenewalShopping.eligibilityCounts.atne) || 0,
                    fteCount: parseInt(currentRenewalShopping.eligibilityCounts.fte) || 0,
                    eligiblesCount: parseInt(currentRenewalShopping.eligibilityCounts.eligible) || 0
                };
            }
            
            // Check if alternate rating method was previously used
            const selectedPlansForAlternateRating = fullProps.renewalShopping?.selectedPlans?.length
                ? fullProps.renewalShopping.selectedPlans
                : fullProps.renewalShoppingHelper?.medical?.selectedPlans;
            const getAlternateRatingMethod = checkAlternateRatingMethodUsed(selectedPlansForAlternateRating);
            
            // Dispatch rate calculation
            dispatch(getCensusRates(
                plansForRateCall,
                platform,
                reqProps.groupSize,
                reqProps.zipObj.zipCode,
                reqProps.effectiveDate,
                reqProps.zipObj.stateCode,
                reqProps.zipObj.countyFIPSCode,
                employeeCounts,
                reqProps.employeeClasses,
                reqProps.employerContribution,
                includeSpecialty,
                reqProps.employees,
                reqProps.companyProfile,
                reqProps.Ny_shop,
                getAlternateRatingMethod
            ));
        }

        const mapOtAreaIndToAreaCoverage = (rawValue) => {
            const otAreaIndMap = { I: 'In', L: 'In', O: 'Out', A: 'All' };
            return otAreaIndMap[rawValue] || rawValue || '';
        };

        if (isMigratedUhic || isMigratedOxford) {
            planDetailsArray = {
                ...planDetailsArray,
                medicalPlans: planDetailsArray.medicalPlans.map((plan) => ({
                    ...plan,
                    areaCoverage: mapOtAreaIndToAreaCoverage(plan.otAreaInd || plan.areaCoverage)
                }))
            };
            if (riderGroupingData) {
                riderGroupingData = {
                    ...riderGroupingData,
                    nonRiderPlans: riderGroupingData.nonRiderPlans.map((plan) => ({
                        ...plan,
                        areaCoverage: mapOtAreaIndToAreaCoverage(plan.otAreaInd || plan.areaCoverage)
                    }))
                };
            }
        }

        // Dispatch plan details to store
        const isMigratedWithRiders = (isMigratedUhic || isMigratedOxford) && riderGroupingData && riderGroupingData.nonRiderPlans.length > 0;
        await dispatch({
            type: types.SERVICE.RS.RECEIVE_REN_ADDITIONAL_PLANS,
            payload: isMigratedWithRiders
                ? { ...planDetailsArray, medicalPlans: riderGroupingData.nonRiderPlans }
                : planDetailsArray,
            renewalShoppingRequest,
            fullProps: fullProps,
            migratedRiderMapping: (isMigratedUhic || isMigratedOxford) ? riderGroupingData?.riderMapping : null
        }); 

    } catch (error) {
        
        logError(
            KEY_NAME,
            UHC_REN_APIS.UHIC_PLAN_DETAILS,
            'uhcServiceHelpers.fetchMedicalPlanDetails',
            planDetailsRequestBody,
            error
        );
        
        // Re-throw to let caller handle the error
        throw error;
    }
};
 
/**
 * Determines the rating count from employeeCounts
 * @param {Array} employeeCounts - Array of employee count objects with type and count properties
 * @returns {string} Rating count value as string
 */
const getRatingCountforPlanCall = (employeeCounts) => {
    // Validate input
    if (!Array.isArray(employeeCounts) || employeeCounts.length === 0) {
        return "0";
    }

    // Find the matching type
    const countObj = employeeCounts.find(ec => 
        ec.type === "FTE" || ec.type === "ATNE" || ec.type === "Eligible"
    );
    
    // Return the count if found and greater than 0, otherwise return "0"
    return (countObj && countObj.count > 0) ? countObj.count.toString() : "0";
}

/**
* Builds request body and calls fetchMigratedUhicMedicalPlans
*/
export const handleMigratedUhicFlow = (renewalShoppingHelper, review, userType, pcisId, companyProfile, employeeCounts, effectiveDate, zipCode, situsState, reqProps) => {
    return (dispatch) => {
        // Extract year from effectiveDate for cocYear field (timezone-safe)
        const cocYear = typeof effectiveDate === 'string' && /^\d{4}-\d{2}-\d{2}/.test(effectiveDate)
            ? parseInt(effectiveDate.substring(0, 4), 10)
            : new Date(effectiveDate).getUTCFullYear();
        
        // Extract groupType to determine brandingName
        const groupType = renewalShoppingHelper?.renewalCaseData?.groupType 
            || review?.renewalCaseData?.groupType;
        
        // Determine brandingName based on groupType
        const brandingName = groupType?.toUpperCase() === 'OXFORD' 
            ? 'Oxford' 
            : 'UnitedHealthcare';
        
        // Build request body for migrated UHIC plans
        const stateValue = situsState || companyProfile?.locations?.[0]?.zipData?.stateCode || '';
        
        const migratedUhcRequestBody = {
            caseEffectiveDate: effectiveDate,
            state: stateValue,
            zipCode: zipCode,
            // county: companyProfile?.locations?.[0]?.zipData?.countyName || '',
            // countyFips: companyProfile?.locations?.[0]?.zipData?.countyFIPSCode || '',
            county: '',
            countyFips: '',
            ratingCount: getRatingCountforPlanCall(employeeCounts), 
            requestType: 'Renewal',
            cocYear: cocYear,
            planCode: renewalShoppingHelper?.medical?.set?.[0]?.[1]?.codeDisplay
                || review?.medical?.set?.[0]?.[1]?.codeDisplay
                || '',
            brandingName: brandingName,
            investmentsPlans: [],
            userType: userType || 'Internal',
            // brokerPCIS: renewalShoppingHelper?.agentData?.[0]?.pcisIds?.[0]
            //     ? parseInt(renewalShoppingHelper.agentData[0].pcisIds[0])
            //     : ''
            brokerPCIS: pcisId || '',
            partnerID: ''
        };
        
        // Add exchange field for New York state (migrated Oxford groups with SHOP eligibility)
        if (stateValue === 'NY') {
            migratedUhcRequestBody.exchange = Boolean(reqProps?.Ny_shop);
        }
 
        // Call the migrated UHIC medical plans API
        return dispatch(fetchMigratedUhicMedicalPlans(migratedUhcRequestBody, reqProps));
    };
};